import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Play, Folder, Radio, TrendingUp, Settings, Globe, Shield, Music, Video, Mic, ArrowRight, CheckCircle2, XCircle, Search, Menu, X, PenTool, Palette, Users, Layout as LayoutIcon, Smartphone, Zap, Star, Headphones, Camera, Tv, User, Briefcase } from 'lucide-react';
import { LineChart, Line, ResponsiveContainer, YAxis, Tooltip } from 'recharts';
const royaltyData = [{
  name: 'W1',
  value: 2400
}, {
  name: 'W2',
  value: 1398
}, {
  name: 'W3',
  value: 9800
}, {
  name: 'W4',
  value: 3908
}, {
  name: 'W5',
  value: 4800
}, {
  name: 'W6',
  value: 3800
}, {
  name: 'W7',
  value: 4300
}];
interface HipHopServersProps {
  onBack?: () => void;
}
export function HipHopServers({
  onBack
}: HipHopServersProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [isLive, setIsLive] = useState(true);
  const [auditQuery, setAuditQuery] = useState('');
  const [auditResult, setAuditResult] = useState<null | {
    score: number;
    issues: string[];
  }>(null);
  const runAudit = () => {
    if (!auditQuery.trim()) return;
    // Simulated audit result
    setAuditResult({
      score: Math.floor(Math.random() * 40) + 35,
      issues: ['No custom domain detected — using free subdomain', 'Social media links not centralized', 'No streaming/VOD infrastructure found', 'Missing press kit or EPK page', 'No direct monetization channels detected']
    });
  };
  return <div className="min-h-screen bg-[#0D0D0D] text-white font-['Montserrat'] selection:bg-[#FFD700] selection:text-black" data-id="element-719">
      {/* Sticky Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#0D0D0D]/80 backdrop-blur-xl border-b border-white/10 px-6 py-4" data-id="element-720">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-721">
          <div className="flex items-center gap-2" data-id="element-722">
            <img src="https://cdn.magicpatterns.com/uploads/iKAQFScHUv6u8yGPemC1Dw/Screenshot_2026-04-17_at_6.46.04_AM.png" alt="HipHopServers Logo" className="h-12 w-auto object-contain" data-id="element-723" />
          </div>

          <nav className="hidden md:flex items-center gap-8 text-sm font-bold uppercase tracking-widest" data-id="element-724">
            <button onClick={() => setActiveSection('home')} className={`${activeSection === 'home' ? 'text-[#FFD700]' : 'text-white'} hover:text-[#FFD700] transition-colors`} data-id="element-725">
              Home
            </button>
            <button onClick={() => setActiveSection('websites')} className={`${activeSection === 'websites' ? 'text-[#FFD700]' : 'text-white'} hover:text-[#FFD700] transition-colors`} data-id="element-726">
              Creator Websites
            </button>
            <button onClick={() => setActiveSection('hosting')} className={`${activeSection === 'hosting' ? 'text-[#FFD700]' : 'text-white'} hover:text-[#FFD700] transition-colors`} data-id="element-727">
              Hosting
            </button>
            <button onClick={() => setActiveSection('streaming')} className={`${activeSection === 'streaming' ? 'text-[#FFD700]' : 'text-white'} hover:text-[#FFD700] transition-colors`} data-id="element-728">
              Streaming
            </button>
            <button onClick={() => setActiveSection('pricing')} className={`${activeSection === 'pricing' ? 'text-[#FFD700]' : 'text-white'} hover:text-[#FFD700] transition-colors`} data-id="element-729">
              Pricing
            </button>
            <button onClick={() => setActiveSection('promotion')} className={`${activeSection === 'promotion' ? 'text-[#FFD700]' : 'text-white'} hover:text-[#FFD700] transition-colors`} data-id="element-730">
              Promotion
            </button>
          </nav>

          <div className="flex items-center gap-4" data-id="element-731">
            {onBack && <button onClick={onBack} className="hidden lg:block text-xs font-bold uppercase tracking-widest hover:text-[#FFD700] transition-colors" data-id="element-732">
                ← Back to Admin
              </button>}
            <button onClick={() => window.dispatchEvent(new CustomEvent('changeTab', {
            detail: 'creator-dashboard'
          }))} className="hidden sm:block bg-[#FFD700] text-black px-6 py-2.5 rounded font-bold text-xs uppercase tracking-widest hover:bg-white transition-all shadow-[0_0_20px_rgba(255,215,0,0.3)]" data-id="element-733">
              Enter Dashboard
            </button>
            <button className="md:hidden text-white p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-734">
              {isMenuOpen ? <X size={24} data-id="element-735" /> : <Menu size={24} data-id="element-736" />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-737">
        {isMenuOpen && <motion.div initial={{
        opacity: 0,
        x: '100%'
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: '100%'
      }} className="fixed inset-0 z-[60] bg-[#0D0D0D] p-8 flex flex-col gap-8" data-id="element-738">
            <div className="flex justify-end" data-id="element-739">
              <button onClick={() => setIsMenuOpen(false)} data-id="element-740">
                <X size={32} data-id="element-741" />
              </button>
            </div>
            <nav className="flex flex-col gap-6 text-2xl font-['Archivo_Black'] uppercase" data-id="element-742">
              {['home', 'websites', 'hosting', 'streaming', 'pricing', 'promotion'].map(section => <button key={section} onClick={() => {
            setActiveSection(section);
            setIsMenuOpen(false);
          }} className={activeSection === section ? 'text-[#FFD700]' : 'text-white'} data-id="element-743">
                  {section.replace('-', ' ')}
                </button>)}
            </nav>
          </motion.div>}
      </AnimatePresence>

      {activeSection === 'home' && <>
          {/* Hero Section */}
          <section className="relative pt-32 md:pt-48 pb-20 md:pb-32 px-6 overflow-hidden" data-id="element-744">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none" data-id="element-745">
              <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#FFD700]/10 blur-[120px] rounded-full" data-id="element-746"></div>
              <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-red-600/10 blur-[100px] rounded-full" data-id="element-747"></div>
            </div>

            <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-748">
              <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="font-['Archivo_Black'] text-4xl md:text-6xl lg:text-7xl uppercase leading-[0.9] mb-6 tracking-tighter" data-id="element-749">
                Build Your Brand.
                <br data-id="element-750" />
                <span className="text-[#FFD700]" data-id="element-751">Own Your Audience.</span>
                <br data-id="element-752" />
                Monetize Content.
              </motion.h1>

              <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto mb-10 font-medium leading-relaxed" data-id="element-753">
                Professional infrastructure for influencers, artists, and
                creators. <br className="hidden md:block" data-id="element-754" />
                Stop renting your audience on social media.
              </motion.p>

              <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6" data-id="element-755">
                <button className="w-full sm:w-auto bg-[#FFD700] text-black px-8 md:px-10 py-4 md:py-5 rounded font-bold uppercase tracking-widest hover:bg-white transition-all text-base md:text-lg shadow-[0_0_30px_rgba(255,215,0,0.2)]" data-id="element-756">
                  Start My Site
                </button>
                <button className="w-full sm:w-auto border-2 border-[#FF0000] text-[#FF0000] px-8 md:px-10 py-4 md:py-5 rounded font-bold uppercase tracking-widest hover:bg-[#FF0000] hover:text-white transition-all text-base md:text-lg shadow-[0_0_30px_rgba(255,0,0,0.2)]" data-id="element-757">
                  Take the Free Creator Audit
                </button>
              </motion.div>

              {/* Brand Audit Search */}
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.35
          }} className="mt-8 md:mt-12 max-w-2xl mx-auto" data-id="element-758">
                <p className="text-[10px] md:text-xs font-bold text-gray-500 uppercase tracking-widest text-center mb-4" data-id="element-759">
                  Quick Brand Audit — Enter your website or social handle
                </p>
                <div className="flex flex-col sm:flex-row bg-[#1A1A1A] border border-white/10 rounded-xl overflow-hidden shadow-2xl" data-id="element-760">
                  <div className="flex-1 flex items-center pl-5 py-3 sm:py-0" data-id="element-761">
                    <Search size={20} className="text-gray-600 shrink-0" data-id="element-762" />
                    <input type="text" value={auditQuery} onChange={e => {
                  setAuditQuery(e.target.value);
                  setAuditResult(null);
                }} onKeyDown={e => e.key === 'Enter' && runAudit()} placeholder="e.g. @artistname or yourdomain.com" className="w-full bg-transparent px-4 py-3 text-white placeholder-gray-600 focus:outline-none font-medium text-sm" data-id="element-763" />
                  </div>
                  <button onClick={runAudit} className="bg-[#FFD700] text-black px-8 py-4 sm:py-0 font-bold text-xs uppercase tracking-widest hover:bg-white transition-all whitespace-nowrap" data-id="element-764">
                    Audit Now
                  </button>
                </div>

                {auditResult && <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} className="mt-6 bg-[#1A1A1A] border border-white/5 rounded-xl p-6 text-left" data-id="element-765">
                    <div className="flex items-center justify-between mb-6" data-id="element-766">
                      <div data-id="element-767">
                        <p className="text-[10px] font-bold text-gray-500 uppercase tracking-widest" data-id="element-768">
                          Brand Health Score
                        </p>
                        <p className="text-4xl font-['Archivo_Black'] text-[#FF0000]" data-id="element-769">
                          {auditResult.score}/100
                        </p>
                      </div>
                      <div className="text-right" data-id="element-770">
                        <span className="px-3 py-1 bg-[#FF0000]/10 border border-[#FF0000]/20 rounded text-[10px] font-bold text-[#FF0000] uppercase tracking-widest" data-id="element-771">
                          Needs Improvement
                        </span>
                      </div>
                    </div>
                    <div className="space-y-3" data-id="element-772">
                      {auditResult.issues.map((issue, i) => <div key={i} className="flex items-start gap-3 text-sm" data-id="element-773">
                          <XCircle size={16} className="text-[#FF0000] shrink-0 mt-0.5" data-id="element-774" />
                          <span className="text-gray-400" data-id="element-775">{issue}</span>
                        </div>)}
                    </div>
                    <button className="mt-6 w-full bg-[#FFD700] text-black py-3 rounded font-bold text-xs uppercase tracking-widest hover:bg-white transition-all" data-id="element-776">
                      Get Your Custom Fix Plan →
                    </button>
                  </motion.div>}
              </motion.div>
            </div>
          </section>

          {/* Celebrity Dashboard Preview */}
          <section className="py-24 px-6 bg-[#1A1A1A]/30" data-id="element-777">
            <div className="max-w-7xl mx-auto" data-id="element-778">
              <div className="text-center mb-16" data-id="element-779">
                <h2 className="font-['Archivo_Black'] text-3xl md:text-5xl uppercase mb-4" data-id="element-780">
                  The Celebrity Dashboard
                </h2>
                <p className="text-gray-500 font-bold uppercase tracking-widest" data-id="element-781">
                  Your entire empire in one high-end view
                </p>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-782">
                {/* Media Vault */}
                <div className="bg-[#1A1A1A] border border-white/5 rounded-2xl p-8 shadow-2xl" data-id="element-783">
                  <div className="flex items-center justify-between mb-8" data-id="element-784">
                    <div className="flex items-center gap-3" data-id="element-785">
                      <Folder className="text-[#FFD700]" size={24} data-id="element-786" />
                      <h3 className="font-bold uppercase tracking-wider" data-id="element-787">
                        Media Vault
                      </h3>
                    </div>
                    <span className="text-[10px] font-bold text-gray-500 uppercase tracking-widest" data-id="element-788">
                      1.2 TB Used
                    </span>
                  </div>

                  <div className="space-y-4" data-id="element-789">
                    {[{
                  name: 'Latest Music Video',
                  type: 'Video',
                  size: '2.4 GB',
                  icon: Video
                }, {
                  name: 'Podcast Masters',
                  type: 'Audio',
                  size: '840 MB',
                  icon: Mic
                }, {
                  name: 'Press Kit 2024',
                  type: 'Folder',
                  size: '12 Items',
                  icon: Folder
                }].map((item, i) => <div key={i} className="flex items-center justify-between p-4 bg-black/40 rounded-xl border border-white/5 hover:border-[#FFD700]/30 transition-colors cursor-pointer group" data-id="element-790">
                        <div className="flex items-center gap-4" data-id="element-791">
                          <div className="p-2 bg-white/5 rounded-lg group-hover:bg-[#FFD700]/10 transition-colors" data-id="element-792">
                            <item.icon size={18} className="text-gray-400 group-hover:text-[#FFD700]" data-id="element-793" />
                          </div>
                          <div data-id="element-794">
                            <p className="text-sm font-bold" data-id="element-795">{item.name}</p>
                            <p className="text-[10px] text-gray-500 font-bold uppercase" data-id="element-796">
                              {item.type}
                            </p>
                          </div>
                        </div>
                        <span className="text-[10px] font-bold text-gray-500" data-id="element-797">
                          {item.size}
                        </span>
                      </div>)}
                  </div>
                </div>

                {/* Streaming Center */}
                <div className="bg-[#1A1A1A] border border-white/5 rounded-2xl p-8 shadow-2xl flex flex-col" data-id="element-798">
                  <div className="flex items-center justify-between mb-8" data-id="element-799">
                    <div className="flex items-center gap-3" data-id="element-800">
                      <Radio className="text-[#FF0000]" size={24} data-id="element-801" />
                      <h3 className="font-bold uppercase tracking-wider" data-id="element-802">
                        Streaming Center
                      </h3>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-803">
                      <span className="text-[10px] font-bold text-gray-500 uppercase tracking-widest" data-id="element-804">
                        Live Status
                      </span>
                      <button onClick={() => setIsLive(!isLive)} className={`w-10 h-5 rounded-full relative transition-colors ${isLive ? 'bg-[#FF0000]' : 'bg-gray-800'}`} data-id="element-805">
                        <motion.div animate={{
                      x: isLive ? 22 : 2
                    }} className="absolute top-1 left-0 w-3 h-3 bg-white rounded-full" data-id="element-806" />
                      </button>
                    </div>
                  </div>

                  <div className="flex-1 flex flex-col justify-center items-center text-center py-8" data-id="element-807">
                    <div className={`w-20 h-20 rounded-full flex items-center justify-center mb-6 border transition-all ${isLive ? 'bg-[#FF0000]/20 border-[#FF0000]/30 shadow-[0_0_30px_rgba(255,0,0,0.2)]' : 'bg-gray-900 border-white/5'}`} data-id="element-808">
                      <Play size={32} className={isLive ? 'text-[#FF0000] ml-1' : 'text-gray-700 ml-1'} data-id="element-809" />
                    </div>
                    <h4 className="text-xl font-bold mb-2" data-id="element-810">
                      {isLive ? 'Wowza Integration Active' : 'Stream Offline'}
                    </h4>
                    <p className="text-sm text-gray-500 mb-8" data-id="element-811">
                      {isLive ? 'Broadcasting to 12.4k viewers' : 'Ready to go live'}
                    </p>

                    <div className="w-full grid grid-cols-2 gap-4" data-id="element-812">
                      <button className="py-3 bg-white/5 rounded-lg text-[10px] font-bold uppercase tracking-widest border border-white/5 hover:bg-white/10 transition-colors" data-id="element-813">
                        VOD Library
                      </button>
                      <button className="py-3 bg-white/5 rounded-lg text-[10px] font-bold uppercase tracking-widest border border-white/5 hover:bg-white/10 transition-colors" data-id="element-814">
                        Stream Settings
                      </button>
                    </div>
                  </div>
                </div>

                {/* Royalty Tracker */}
                <div className="bg-[#1A1A1A] border border-white/5 rounded-2xl p-8 shadow-2xl" data-id="element-815">
                  <div className="flex items-center justify-between mb-8" data-id="element-816">
                    <div className="flex items-center gap-3" data-id="element-817">
                      <TrendingUp className="text-emerald-500" size={24} data-id="element-818" />
                      <h3 className="font-bold uppercase tracking-wider" data-id="element-819">
                        Royalty Tracker
                      </h3>
                    </div>
                    <span className="text-[10px] font-bold text-emerald-500 uppercase tracking-widest" data-id="element-820">
                      +24% Growth
                    </span>
                  </div>

                  <div className="mb-8" data-id="element-821">
                    <p className="text-[10px] font-bold text-gray-500 uppercase tracking-widest mb-1" data-id="element-822">
                      Monthly Content Revenue
                    </p>
                    <h4 className="text-4xl font-['Archivo_Black'] tracking-tighter" data-id="element-823">
                      $12,840.00
                    </h4>
                  </div>

                  <div className="h-[120px] w-full" data-id="element-824">
                    <ResponsiveContainer width="100%" height="100%" data-id="element-825">
                      <LineChart data={royaltyData} data-id="element-826">
                        <Line type="monotone" dataKey="value" stroke="#10B981" strokeWidth={3} dot={false} data-id="element-827" />
                        <Tooltip contentStyle={{
                      backgroundColor: '#0D0D0D',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '10px'
                    }} data-id="element-828" />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>

                  <div className="mt-8 grid grid-cols-2 gap-4" data-id="element-829">
                    <button className="flex items-center justify-center gap-2 py-3 bg-[#FFD700] text-black rounded-lg text-[10px] font-bold uppercase tracking-widest hover:bg-white transition-colors" data-id="element-830">
                      <Settings size={14} data-id="element-831" /> Manage Hosting
                    </button>
                    <button className="flex items-center justify-center gap-2 py-3 bg-white/5 rounded-lg text-[10px] font-bold uppercase tracking-widest border border-white/5 hover:bg-white/10 transition-colors" data-id="element-832">
                      Update Tour Dates
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Section 2: Who We Help */}
          <section className="py-24 px-6" data-id="element-833">
            <div className="max-w-7xl mx-auto" data-id="element-834">
              <div className="text-center mb-16" data-id="element-835">
                <h2 className="font-['Archivo_Black'] text-3xl md:text-5xl uppercase mb-4" data-id="element-836">
                  Who We Help
                </h2>
                <p className="text-gray-500 font-bold uppercase tracking-widest" data-id="element-837">
                  Tailored infrastructure for the elite creator economy
                </p>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6" data-id="element-838">
                {[{
              name: 'Influencers',
              icon: Star
            }, {
              name: 'Musicians',
              icon: Music
            }, {
              name: 'DJs',
              icon: Headphones
            }, {
              name: 'Podcasters',
              icon: Mic
            }, {
              name: 'Social Marketers',
              icon: Zap
            }, {
              name: 'Content Creators',
              icon: Camera
            }, {
              name: 'Streamers',
              icon: Tv
            }, {
              name: 'Public Figures',
              icon: User
            }, {
              name: 'Entertainment Brands',
              icon: Briefcase
            }].map((audience, i) => <motion.div key={i} whileHover={{
              y: -5
            }} className="bg-[#1A1A1A] border border-white/5 p-6 rounded-2xl flex flex-col items-center text-center gap-4 group hover:border-[#FFD700]/30 transition-all" data-id="element-839">
                    <div className="w-12 h-12 bg-white/5 rounded-xl flex items-center justify-center group-hover:bg-[#FFD700]/10 transition-colors" data-id="element-840">
                      <audience.icon className="text-gray-400 group-hover:text-[#FFD700]" size={24} data-id="element-841" />
                    </div>
                    <span className="text-xs font-bold uppercase tracking-wider" data-id="element-842">
                      {audience.name}
                    </span>
                  </motion.div>)}
              </div>
            </div>
          </section>

          {/* Section 3: Why a Website Instead of Just Social Media? */}
          <section className="py-24 px-6 bg-[#1A1A1A]/30" data-id="element-843">
            <div className="max-w-7xl mx-auto" data-id="element-844">
              <div className="text-center mb-16" data-id="element-845">
                <h2 className="font-['Archivo_Black'] text-3xl md:text-5xl uppercase mb-4" data-id="element-846">
                  The Ownership Gap
                </h2>
                <p className="text-gray-500 font-bold uppercase tracking-widest" data-id="element-847">
                  Why a website beats social media every time
                </p>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-848">
                {/* Social Media Only */}
                <div className="bg-red-500/5 border border-red-500/10 rounded-3xl p-8 md:p-12" data-id="element-849">
                  <div className="flex items-center gap-4 mb-8" data-id="element-850">
                    <div className="w-12 h-12 bg-red-500/10 rounded-xl flex items-center justify-center" data-id="element-851">
                      <XCircle className="text-red-500" size={28} data-id="element-852" />
                    </div>
                    <h3 className="font-['Archivo_Black'] text-2xl uppercase" data-id="element-853">
                      Social Media Only
                    </h3>
                  </div>
                  <ul className="space-y-6" data-id="element-854">
                    {[{
                  title: 'Limited Control',
                  desc: 'You follow their rules, their layout, and their restrictions.'
                }, {
                  title: 'Algorithm Dependence',
                  desc: 'One update can wipe out your reach overnight.'
                }, {
                  title: 'Links Scattered Everywhere',
                  desc: 'Bio links are messy and lose potential conversions.'
                }, {
                  title: 'No Ownership of Audience',
                  desc: "You don't own your followers' data or contact info."
                }].map((item, i) => <li key={i} className="flex gap-4" data-id="element-855">
                        <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-500 shrink-0" data-id="element-856" />
                        <div data-id="element-857">
                          <p className="font-bold uppercase text-sm mb-1" data-id="element-858">
                            {item.title}
                          </p>
                          <p className="text-gray-500 text-sm leading-relaxed" data-id="element-859">
                            {item.desc}
                          </p>
                        </div>
                      </li>)}
                  </ul>
                </div>

                {/* HipHopServers Website */}
                <div className="bg-[#FFD700]/5 border border-[#FFD700]/10 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(255,215,0,0.05)]" data-id="element-860">
                  <div className="flex items-center gap-4 mb-8" data-id="element-861">
                    <div className="w-12 h-12 bg-[#FFD700]/10 rounded-xl flex items-center justify-center" data-id="element-862">
                      <CheckCircle2 className="text-[#FFD700]" size={28} data-id="element-863" />
                    </div>
                    <h3 className="font-['Archivo_Black'] text-2xl uppercase" data-id="element-864">
                      HipHopServers Website
                    </h3>
                  </div>
                  <ul className="space-y-6" data-id="element-865">
                    {[{
                  title: 'Centralized Content',
                  desc: 'Your music, videos, and merch all in one professional hub.'
                }, {
                  title: 'Own Your Brand & Audience',
                  desc: 'Direct access to fan emails and data with zero filters.'
                }, {
                  title: 'Monetization Tools',
                  desc: 'Keep 100% of your revenue with built-in e-commerce.'
                }, {
                  title: 'Professional Appearance',
                  desc: 'Enterprise-grade design that commands industry respect.'
                }, {
                  title: 'Search Engine Visibility',
                  desc: 'Get found on Google, not just within a social app.'
                }, {
                  title: 'One Link For Everything',
                  desc: 'A single, powerful destination for your entire empire.'
                }].map((item, i) => <li key={i} className="flex gap-4" data-id="element-866">
                        <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#FFD700] shrink-0" data-id="element-867" />
                        <div data-id="element-868">
                          <p className="font-bold uppercase text-sm mb-1 text-white" data-id="element-869">
                            {item.title}
                          </p>
                          <p className="text-gray-400 text-sm leading-relaxed" data-id="element-870">
                            {item.desc}
                          </p>
                        </div>
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Section 5: Sample Creator Showcase */}
          <section className="py-24 px-6" data-id="element-871">
            <div className="max-w-7xl mx-auto" data-id="element-872">
              <div className="text-center mb-16" data-id="element-873">
                <h2 className="font-['Archivo_Black'] text-3xl md:text-5xl uppercase mb-4" data-id="element-874">
                  Creator Showcase
                </h2>
                <p className="text-gray-500 font-bold uppercase tracking-widest" data-id="element-875">
                  See how the elite build their online presence
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-876">
                {[{
              title: 'Music Artist Page',
              desc: 'Streaming integration, tour dates, and merch store.',
              image: 'https://images.unsplash.com/photo-1514525253361-bee8718a74a2?auto=format&fit=crop&q=80&w=800',
              features: ['Spotify Sync', 'Ticket Sales', 'VIP Access']
            }, {
              title: 'Podcast Hub',
              desc: 'Episode library, guest booking, and listener analytics.',
              image: 'https://images.unsplash.com/photo-1590602847861-f357a9332bbc?auto=format&fit=crop&q=80&w=800',
              features: ['RSS Feed Auto-Sync', 'Guest Forms', 'Ad Management']
            }, {
              title: 'Influencer Landing Page',
              desc: 'Brand deals, media kit, and social feed aggregation.',
              image: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&q=80&w=800',
              features: ['Live Social Feed', 'Media Kit PDF', 'Brand Inquiries']
            }, {
              title: 'Public Figure / Speaker',
              desc: 'Booking calendar, press mentions, and keynote library.',
              image: 'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?auto=format&fit=crop&q=80&w=800',
              features: ['Calendar Sync', 'Speaker Reel', 'Press Mentions']
            }].map((showcase, i) => <motion.div key={i} whileHover={{
              y: -10
            }} className="group bg-[#1A1A1A] border border-white/5 rounded-3xl overflow-hidden hover:border-[#FFD700]/30 transition-all" data-id="element-877">
                    <div className="aspect-video relative overflow-hidden" data-id="element-878">
                      <img src={showcase.image} alt={showcase.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-879" />
                      <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] to-transparent opacity-60" data-id="element-880" />
                      <div className="absolute bottom-6 left-6 right-6" data-id="element-881">
                        <div className="flex gap-2 mb-3" data-id="element-882">
                          {showcase.features.map((f, j) => <span key={j} className="px-2 py-1 bg-[#FFD700]/10 border border-[#FFD700]/20 rounded text-[10px] font-bold text-[#FFD700] uppercase tracking-widest" data-id="element-883">
                              {f}
                            </span>)}
                        </div>
                        <h3 className="font-['Archivo_Black'] text-2xl uppercase" data-id="element-884">
                          {showcase.title}
                        </h3>
                      </div>
                    </div>
                    <div className="p-8" data-id="element-885">
                      <p className="text-gray-400 mb-6" data-id="element-886">{showcase.desc}</p>
                      <button className="text-[#FFD700] font-bold uppercase tracking-widest flex items-center gap-2 group/btn" data-id="element-887">
                        View Live Demo{' '}
                        <ArrowRight className="group-hover/btn:translate-x-2 transition-transform" size={18} data-id="element-888" />
                      </button>
                    </div>
                  </motion.div>)}
              </div>
            </div>
          </section>

          {/* Social vs Owned Comparison */}
          <section className="py-24 px-6" data-id="element-889">
            <div className="max-w-5xl mx-auto" data-id="element-890">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-891">
                <div className="space-y-8" data-id="element-892">
                  <div className="p-8 bg-red-500/5 border border-red-500/10 rounded-2xl" data-id="element-893">
                    <div className="flex items-center gap-3 mb-6" data-id="element-894">
                      <XCircle className="text-red-500" size={24} data-id="element-895" />
                      <h3 className="font-['Archivo_Black'] text-2xl uppercase" data-id="element-896">
                        Social Media (The Risk)
                      </h3>
                    </div>
                    <ul className="space-y-4" data-id="element-897">
                      {['Algorithm Dependence', 'Rented Audience', 'Zero Control'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-400 font-bold uppercase tracking-wider text-sm" data-id="element-898">
                          <div className="w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-899"></div>
                          {item}
                        </li>)}
                    </ul>
                  </div>

                  <div className="p-8 bg-[#FFD700]/5 border border-[#FFD700]/10 rounded-2xl shadow-[0_0_40px_rgba(255,215,0,0.05)]" data-id="element-900">
                    <div className="flex items-center gap-3 mb-6" data-id="element-901">
                      <CheckCircle2 className="text-[#FFD700]" size={24} data-id="element-902" />
                      <h3 className="font-['Archivo_Black'] text-2xl uppercase" data-id="element-903">
                        HipHopServers (The Power)
                      </h3>
                    </div>
                    <ul className="space-y-4" data-id="element-904">
                      {['Platform Ownership', 'Direct-to-Fan', 'Centralized Revenue'].map((item, i) => <li key={i} className="flex items-center gap-3 text-white font-bold uppercase tracking-wider text-sm" data-id="element-905">
                          <div className="w-1.5 h-1.5 rounded-full bg-[#FFD700]" data-id="element-906"></div>
                          {item}
                        </li>)}
                    </ul>
                  </div>
                </div>

                <div className="space-y-6" data-id="element-907">
                  <h2 className="font-['Archivo_Black'] text-4xl md:text-6xl uppercase leading-none" data-id="element-908">
                    Stop Renting Your Audience.
                  </h2>
                  <p className="text-gray-400 text-lg leading-relaxed" data-id="element-909">
                    Social platforms change their algorithms overnight. One
                    update can wipe out your reach. With HipHopServers, you own
                    the database, the content, and the relationship with your
                    fans.
                  </p>
                  <button className="text-[#FFD700] font-bold uppercase tracking-widest flex items-center gap-2 group" data-id="element-910">
                    Learn about Platform Ownership{' '}
                    <ArrowRight className="group-hover:translate-x-2 transition-transform" data-id="element-911" />
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* Pricing Tiers */}
          <section className="py-24 px-6 bg-[#1A1A1A]/30" data-id="element-912">
            <div className="max-w-7xl mx-auto text-center" data-id="element-913">
              <h2 className="font-['Archivo_Black'] text-3xl md:text-5xl uppercase mb-16" data-id="element-914">
                Service & Pricing Tiers
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-915">
                {[{
              name: 'Launch Page',
              price: '49',
              desc: 'Link hubs & single-pagers for new influencers.',
              features: ['Custom Link Hub', 'Single Page Site', 'Basic Analytics', 'Niishcloud Hosting']
            }, {
              name: 'Creator Pro',
              price: '149',
              desc: '5-page media sites with SEO for active artists.',
              features: ['5-Page Media Site', 'SEO Optimization', 'Media Vault Access', 'Custom Domain'],
              popular: true
            }, {
              name: 'Entertainment Brand',
              price: '499',
              desc: 'The "Full Package"—Streaming-ready, custom press kits, and premium branding.',
              features: ['Streaming Ready', 'Custom Press Kits', 'Premium Branding', 'Priority Support']
            }].map((tier, i) => <div key={i} className={`p-10 rounded-2xl border ${tier.popular ? 'bg-[#1A1A1A] border-[#FFD700] shadow-[0_0_50px_rgba(255,215,0,0.1)] relative' : 'bg-black/40 border-white/5'}`} data-id="element-916">
                    {tier.popular && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#FFD700] text-black px-4 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest" data-id="element-917">
                        Most Popular
                      </div>}
                    <h3 className="font-['Archivo_Black'] text-2xl uppercase mb-2" data-id="element-918">
                      {tier.name}
                    </h3>
                    <p className="text-gray-500 text-xs font-bold uppercase tracking-widest mb-8" data-id="element-919">
                      {tier.desc}
                    </p>

                    <div className="mb-10" data-id="element-920">
                      <span className="text-4xl font-['Archivo_Black']" data-id="element-921">
                        ${tier.price}
                      </span>
                      <span className="text-gray-500 text-sm font-bold uppercase tracking-widest" data-id="element-922">
                        /mo
                      </span>
                    </div>

                    <ul className="text-left space-y-4 mb-10" data-id="element-923">
                      {tier.features.map((f, j) => <li key={j} className="flex items-center gap-3 text-sm font-medium text-gray-400" data-id="element-924">
                          <CheckCircle2 size={16} className="text-[#FFD700]" data-id="element-925" />
                          {f}
                        </li>)}
                    </ul>

                    <button className={`w-full py-4 rounded font-bold uppercase tracking-widest transition-all ${tier.popular ? 'bg-[#FFD700] text-black hover:bg-white' : 'bg-white/5 text-white border border-white/10 hover:bg-white/10'}`} data-id="element-926">
                      Get Started
                    </button>
                  </div>)}
              </div>
            </div>
          </section>

          {/* Creator Audit Funnel */}
          <section className="py-24 px-6" data-id="element-927">
            <div className="max-w-4xl mx-auto" data-id="element-928">
              <div className="bg-gradient-to-br from-[#FFD700]/20 to-red-600/10 p-12 rounded-3xl border border-[#FFD700]/20 relative overflow-hidden" data-id="element-929">
                <div className="relative z-10 text-center space-y-8" data-id="element-930">
                  <h2 className="font-['Archivo_Black'] text-3xl md:text-5xl uppercase leading-tight" data-id="element-931">
                    Are you losing 40% of your traffic to social media
                    algorithms?
                  </h2>
                  <p className="text-xl text-gray-300 font-medium" data-id="element-932">
                    Take the Free Creator Audit and get a custom strategy to
                    centralize your audience.
                  </p>

                  <div className="max-w-md mx-auto space-y-4" data-id="element-933">
                    <input type="email" placeholder="Enter your email address" className="w-full px-6 py-4 bg-black/40 border border-white/10 rounded-lg focus:outline-none focus:border-[#FFD700] transition-colors font-bold text-center" data-id="element-934" />
                    <button className="w-full bg-[#FFD700] text-black py-4 rounded-lg font-bold uppercase tracking-widest hover:bg-white transition-all shadow-xl" data-id="element-935">
                      Get My Free Audit
                    </button>
                  </div>
                </div>

                <div className="absolute -top-24 -right-24 w-64 h-64 bg-[#FFD700]/20 blur-[100px] rounded-full" data-id="element-936"></div>
                <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-red-600/20 blur-[100px] rounded-full" data-id="element-937"></div>
              </div>
            </div>
          </section>

          {/* Promotion Teaser on Home */}
          <section className="py-24 px-6 bg-black" data-id="element-938">
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-939">
              <div className="flex-1 space-y-6" data-id="element-940">
                <span className="text-[#FFD700] font-bold uppercase tracking-[0.3em] text-xs" data-id="element-941">
                  Viral Growth Engine
                </span>
                <h2 className="font-['Archivo_Black'] text-4xl md:text-6xl uppercase leading-none" data-id="element-942">
                  Go Viral. <br data-id="element-943" />
                  <span className="text-white/50" data-id="element-944">Stay Relevant.</span>
                </h2>
                <p className="text-gray-400 text-lg" data-id="element-945">
                  Our promotion engine handles your social media, content
                  engagement, and blogging so you can focus on the art.
                </p>
                <button onClick={() => setActiveSection('promotion')} className="bg-white text-black px-8 py-4 rounded font-bold uppercase tracking-widest hover:bg-[#FFD700] transition-all" data-id="element-946">
                  Explore Promotion Packages
                </button>
              </div>
              <div className="flex-1 grid grid-cols-2 gap-4" data-id="element-947">
                <div className="bg-[#1A1A1A] p-6 rounded-2xl border border-white/5 space-y-4" data-id="element-948">
                  <TrendingUp className="text-[#FFD700]" size={32} data-id="element-949" />
                  <h3 className="font-bold uppercase text-sm" data-id="element-950">Engagement</h3>
                  <p className="text-xs text-gray-500" data-id="element-951">
                    Real fan interaction across all platforms.
                  </p>
                </div>
                <div className="bg-[#1A1A1A] p-6 rounded-2xl border border-white/5 space-y-4 mt-8" data-id="element-952">
                  <Video className="text-[#FFD700]" size={32} data-id="element-953" />
                  <h3 className="font-bold uppercase text-sm" data-id="element-954">
                    Reels & Shorts
                  </h3>
                  <p className="text-xs text-gray-500" data-id="element-955">
                    High-impact short form content production.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </>}

      {activeSection === 'promotion' && <section className="pt-48 pb-32 px-6 max-w-7xl mx-auto" data-id="element-956">
          <div className="text-center mb-16" data-id="element-957">
            <h2 className="font-['Archivo_Black'] text-4xl md:text-6xl uppercase mb-6" data-id="element-958">
              Celebrity <span className="text-[#FFD700]" data-id="element-959">Promotion</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-960">
              Elite marketing services designed to amplify your reach and
              dominate the cultural conversation.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-961">
            {[{
          name: 'Social Surge',
          price: '899',
          icon: Globe,
          desc: 'Full social media management and growth hacking.',
          features: ['Daily Content Posting', 'Engagement Groups', 'Influencer Outreach', 'Analytics Dashboard']
        }, {
          name: 'Content Factory',
          price: '1,499',
          icon: Video,
          desc: 'Professional reels, shorts, and TikTok production.',
          features: ['15 Custom Reels/mo', 'Professional Editing', 'Trending Audio Strategy', 'Cross-Platform Distribution']
        }, {
          name: 'The Blog Empire',
          price: '599',
          icon: PenTool,
          desc: 'SEO-optimized blogging and press releases.',
          features: ['4 Long-form Articles', 'Press Release Distribution', 'SEO Keyword Research', 'Fan Newsletter Sync']
        }, {
          name: 'Graphic Identity',
          price: '750',
          icon: Palette,
          desc: 'High-end visual assets for your brand.',
          features: ['Tour Posters', 'Album/Single Art', 'Social Templates', 'Brand Guidelines']
        }, {
          name: 'Engagement Pro',
          price: '1,200',
          icon: Users,
          desc: 'Massive engagement and community management.',
          features: ['Comment Moderation', 'DM Management', 'Fan Community Building', 'Viral Thread Creation']
        }, {
          name: 'Full Empire Suite',
          price: '3,999',
          icon: Shield,
          desc: 'The ultimate promotion package for top-tier talent.',
          features: ['Everything in all tiers', 'Dedicated Manager', 'Crisis Management', 'Priority Ad Placement'],
          popular: true
        }].map((pkg, i) => <div key={i} className={`p-8 rounded-2xl border ${pkg.popular ? 'bg-[#1A1A1A] border-[#FFD700] shadow-[0_0_40px_rgba(255,215,0,0.1)]' : 'bg-black/40 border-white/5'}`} data-id="element-962">
                <pkg.icon className="text-[#FFD700] mb-6" size={32} data-id="element-963" />
                <h3 className="text-2xl font-['Archivo_Black'] uppercase mb-2" data-id="element-964">
                  {pkg.name}
                </h3>
                <p className="text-gray-500 text-xs font-bold uppercase mb-6" data-id="element-965">
                  {pkg.desc}
                </p>
                <div className="mb-8" data-id="element-966">
                  <span className="text-3xl font-['Archivo_Black']" data-id="element-967">
                    ${pkg.price}
                  </span>
                  <span className="text-gray-500 text-sm" data-id="element-968">/mo</span>
                </div>
                <ul className="space-y-3 mb-8" data-id="element-969">
                  {pkg.features.map((f, j) => <li key={j} className="flex items-center gap-2 text-sm text-gray-400" data-id="element-970">
                      <CheckCircle2 size={14} className="text-[#FFD700]" data-id="element-971" /> {f}
                    </li>)}
                </ul>
                <button className={`w-full py-3 rounded font-bold uppercase tracking-widest transition-all ${pkg.popular ? 'bg-[#FFD700] text-black hover:bg-white' : 'bg-white/5 text-white border border-white/10 hover:bg-white/10'}`} data-id="element-972">
                  Select Package
                </button>
              </div>)}
          </div>
        </section>}

      {activeSection === 'websites' && <section className="pt-48 pb-32 px-6 max-w-7xl mx-auto" data-id="element-973">
          <div className="text-center mb-16" data-id="element-974">
            <h2 className="font-['Archivo_Black'] text-4xl md:text-6xl uppercase mb-6" data-id="element-975">
              Creator Websites
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-976">
              High-performance, SEO-optimized sites built for the entertainment
              industry.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-977">
            <div className="bg-[#1A1A1A] p-8 rounded-2xl border border-white/5" data-id="element-978">
              <Globe className="text-[#FFD700] mb-6" size={48} data-id="element-979" />
              <h3 className="text-2xl font-bold uppercase mb-4" data-id="element-980">
                Custom Domains
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-981">
                Full ownership of your URL. No subdomains, no third-party
                branding.
              </p>
              <ul className="space-y-3 text-sm text-gray-300" data-id="element-982">
                <li className="flex items-center gap-2" data-id="element-983">
                  <CheckCircle2 size={16} className="text-[#FFD700]" data-id="element-984" /> SSL
                  Included
                </li>
                <li className="flex items-center gap-2" data-id="element-985">
                  <CheckCircle2 size={16} className="text-[#FFD700]" data-id="element-986" /> Global
                  CDN
                </li>
              </ul>
            </div>
            <div className="bg-[#1A1A1A] p-8 rounded-2xl border border-white/5" data-id="element-987">
              <Shield className="text-[#FFD700] mb-6" size={48} data-id="element-988" />
              <h3 className="text-2xl font-bold uppercase mb-4" data-id="element-989">
                Enterprise Security
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-990">
                Protect your content and fan data with military-grade
                encryption.
              </p>
              <ul className="space-y-3 text-sm text-gray-300" data-id="element-991">
                <li className="flex items-center gap-2" data-id="element-992">
                  <CheckCircle2 size={16} className="text-[#FFD700]" data-id="element-993" /> DDoS
                  Protection
                </li>
                <li className="flex items-center gap-2" data-id="element-994">
                  <CheckCircle2 size={16} className="text-[#FFD700]" data-id="element-995" /> Daily
                  Backups
                </li>
              </ul>
            </div>
          </div>
        </section>}

      {activeSection === 'hosting' && <section className="pt-48 pb-32 px-6 max-w-7xl mx-auto text-center" data-id="element-996">
          <h2 className="font-['Archivo_Black'] text-4xl md:text-6xl uppercase mb-6" data-id="element-997">
            Pro Hosting
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-16" data-id="element-998">
            Powered by Niishcloud enterprise infrastructure. Built for massive
            traffic spikes.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-999">
            {[{
          title: '99.9% Uptime',
          icon: Globe
        }, {
          title: 'Unlimited Bandwidth',
          icon: TrendingUp
        }, {
          title: '24/7 Support',
          icon: Mic
        }].map((item, i) => <div key={i} className="p-10 bg-[#1A1A1A] rounded-2xl border border-white/5" data-id="element-1000">
                <item.icon className="text-[#FFD700] mx-auto mb-6" size={40} data-id="element-1001" />
                <h3 className="font-bold uppercase text-xl" data-id="element-1002">{item.title}</h3>
              </div>)}
          </div>
        </section>}

      {activeSection === 'streaming' && <section className="pt-48 pb-32 px-6 max-w-7xl mx-auto" data-id="element-1003">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-1004">
            <div data-id="element-1005">
              <h2 className="font-['Archivo_Black'] text-4xl md:text-6xl uppercase mb-8" data-id="element-1006">
                Live <span className="text-[#FF0000]" data-id="element-1007">Streaming</span>
              </h2>
              <p className="text-xl text-gray-400 mb-8" data-id="element-1008">
                Broadcast directly to your fans without platform censorship or
                revenue cuts.
              </p>
              <div className="space-y-6" data-id="element-1009">
                <div className="flex gap-4" data-id="element-1010">
                  <div className="w-12 h-12 bg-[#FF0000]/10 rounded-lg flex items-center justify-center shrink-0" data-id="element-1011">
                    <Play className="text-[#FF0000]" size={24} data-id="element-1012" />
                  </div>
                  <div data-id="element-1013">
                    <h4 className="font-bold uppercase" data-id="element-1014">4K Ultra HD</h4>
                    <p className="text-gray-500 text-sm" data-id="element-1015">
                      Crystal clear quality for your performances.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-1016">
                  <div className="w-12 h-12 bg-[#FF0000]/10 rounded-lg flex items-center justify-center shrink-0" data-id="element-1017">
                    <Radio className="text-[#FF0000]" size={24} data-id="element-1018" />
                  </div>
                  <div data-id="element-1019">
                    <h4 className="font-bold uppercase" data-id="element-1020">Low Latency</h4>
                    <p className="text-gray-500 text-sm" data-id="element-1021">
                      Real-time interaction with your audience.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="aspect-video bg-[#1A1A1A] rounded-3xl border border-white/10 overflow-hidden relative group" data-id="element-1022">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-1023">
                <div className="w-20 h-20 bg-[#FF0000] rounded-full flex items-center justify-center shadow-[0_0_50px_rgba(255,0,0,0.4)] group-hover:scale-110 transition-transform cursor-pointer" data-id="element-1024">
                  <Play className="text-white ml-1" size={32} data-id="element-1025" />
                </div>
              </div>
              <div className="absolute top-6 left-6 flex items-center gap-2" data-id="element-1026">
                <div className="w-2 h-2 bg-[#FF0000] rounded-full animate-pulse" data-id="element-1027"></div>
                <span className="text-[10px] font-bold uppercase tracking-widest" data-id="element-1028">
                  Live Preview
                </span>
              </div>
            </div>
          </div>
        </section>}

      {activeSection === 'pricing' && <section className="pt-48 pb-32 px-6" data-id="element-1029">
          <div className="max-w-7xl mx-auto text-center" data-id="element-1030">
            <h2 className="font-['Archivo_Black'] text-4xl md:text-6xl uppercase mb-16" data-id="element-1031">
              Simple Pricing
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1032">
              {[{
            name: 'Launch Page',
            price: '49',
            features: ['Link Hub', '1 Page', 'Basic Analytics']
          }, {
            name: 'Creator Pro',
            price: '149',
            features: ['5 Pages', 'SEO', 'Media Vault'],
            popular: true
          }, {
            name: 'Enterprise',
            price: '499',
            features: ['Streaming', 'Press Kits', 'Priority Support']
          }].map((tier, i) => <div key={i} className={`p-10 rounded-2xl border ${tier.popular ? 'bg-[#1A1A1A] border-[#FFD700]' : 'bg-black/40 border-white/5'}`} data-id="element-1033">
                  <h3 className="font-['Archivo_Black'] text-2xl uppercase mb-4" data-id="element-1034">
                    {tier.name}
                  </h3>
                  <div className="text-4xl font-['Archivo_Black'] mb-8" data-id="element-1035">
                    ${tier.price}
                    <span className="text-sm text-gray-500" data-id="element-1036">/mo</span>
                  </div>
                  <ul className="space-y-4 mb-10 text-left" data-id="element-1037">
                    {tier.features.map((f, j) => <li key={j} className="flex items-center gap-3 text-sm" data-id="element-1038">
                        <CheckCircle2 size={16} className="text-[#FFD700]" data-id="element-1039" />{' '}
                        {f}
                      </li>)}
                  </ul>
                  <button className={`w-full py-4 rounded font-bold uppercase tracking-widest ${tier.popular ? 'bg-[#FFD700] text-black' : 'bg-white/5 border border-white/10'}`} data-id="element-1040">
                    Select Plan
                  </button>
                </div>)}
            </div>
          </div>
        </section>}

      {/* Footer */}
      <footer className="py-12 px-6 border-t border-white/5" data-id="element-1041">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-1042">
          <div className="flex items-center gap-2" data-id="element-1043">
            <img src="https://cdn.magicpatterns.com/uploads/iKAQFScHUv6u8yGPemC1Dw/Screenshot_2026-04-17_at_6.46.04_AM.png" alt="HipHopServers Logo" className="h-10 w-auto object-contain" data-id="element-1044" />
          </div>

          <p className="text-[10px] font-bold text-gray-600 uppercase tracking-[0.2em]" data-id="element-1045">
            Powered by enterprise-grade Niishcloud infrastructure
          </p>

          <div className="flex gap-6 text-[10px] font-bold text-gray-500 uppercase tracking-widest" data-id="element-1046">
            <a href="#" className="hover:text-white transition-colors" data-id="element-1047">
              Privacy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-1048">
              Terms
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-1049">
              Contact
            </a>
          </div>
        </div>
      </footer>
    </div>;
}